<template>
  <div>
    <Banner />
    <main id="main-content" class="page page--inbox">
      <div class="page__content">
        <div class="sheet sheet--inbox">
          <Heading title="Imbox" />
          <div class="inbox-unseens">
            <h5 class="inbox-unseens__header">
              <span class="inbox-unseens__label">New for you</span>
            </h5>
          </div>
          <Posting
            isNew="true"
            heading="Why I want to be your next Senior Designer 👋"
            detail="Nicola Bolton"
            summary="Hi! Nice to meet you, I'm Nicola. I want to be your next Product Designer. I’m a hybrid designer and developer with an obsession for clean, intuitive design."
            date="Oct 12"
            profile="nicola-icon.jpg"
            url="/topics/letter-to-hey"
          />
          <Posting
            isNew="true"
            heading="Really Important: Don’t forget to check out my resume"
            detail="Nicola Bolton"
            summary="Press H to load the menu from anywhere to access more information..."
            date="Oct 12"
            profile="nicola-icon.jpg"
            url="/resume"
          />
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import Heading from "@/components/Heading";
import Banner from "@/components/Banner";
import Posting from "@/components/Posting";

export default {
  name: "Imbox",
  metaInfo: {
    title: "Imbox",
    titleTemplate: "%s | HEY"
  },
  components: {
    Heading,
    Banner,
    Posting
  }
};
</script>
